import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-qb-expense-list',
  templateUrl: './qb-expense-list.component.html',
  styleUrls: ['./qb-expense-list.component.css'],
})
export class QbExpenseListComponent {
  url: string = 'quickbooks';
  data: Array<any> = [];
  isLoading: boolean = false;
  apiUrl = environment.apiUrl;
  step = 1;
  isPayroll: boolean = false;
  resumenCards = [
    {
      label: '',
      value: 0,
      icon: 'fas fa-users',
      bgClass: 'bg-white',
      //desc: 'Staff &+',
      desc: 'Quick Books',
      route: '/numbers/accounting',
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Tax compliance',
      route: null,
    },
    {
      label: '',
      value: 0,
      icon: 'fas fa-receipt',
      bgClass: 'bg-white',
      desc: 'Invoices',
      route: '/numbers/accounting/invoices',
    },
    /* {
      label: '',
      value: 0,
      icon: 'fas fa-money-bill',
      bgClass: 'bg-white',
      desc: 'Bills',
      route: '/numbers/accounting/external',
    }, */
  ];

  constructor(
    private dataService: DataService,
    private messageService: MessageService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getData();
    const currentPath = this.router.url.split('/')[3];
    console.log('path:', currentPath);

    if (currentPath === 'payrolls') {
      this.isPayroll = true;
    }
  }

  /*  getData() {
    this.isLoading = true;
    this.dataService.getData(`${this.url}/expenses`).subscribe((response) => {
      console.log('expenses', response);
      this.data = response.data.QueryResponse.Purchase;
      this.isLoading = false;
    });
  } */

  getData() {
    this.isLoading = true;
    this.dataService.getData(`${this.url}/expenses`).subscribe((response) => {
      const allExpenses = response.data.QueryResponse.Purchase || [];
      console.log('allExpenses', allExpenses);

      // Filtrar para excluir los que tengan líneas con DetailType "payroll expenses"
      this.data = allExpenses.filter((expense) => {
        if (!expense.Line || !expense.Line.length) return true; // si no tiene líneas, mantener
        // Si alguna línea es payroll expenses, lo excluimos
        return !expense.Line.some(
          (line) =>
            line.DetailType === 'AccountBasedExpenseLineDetail' &&
            line.AccountBasedExpenseLineDetail?.AccountRef?.name ===
              'Payroll expenses'
        );
      });

      this.isLoading = false;
    });
  }

  deleteData(id: string, syncToken: string): void {
    if (!confirm('You want to delete the record?')) {
      return;
    }

    this.isLoading = true;

    this.dataService
      .deleteData(`${this.url}/deactivateExpense/${id}/${syncToken}`)
      .subscribe((response) => {
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }

        this.getData();
      });
  }

  changeStep(step: number) {
    this.step = step;
  }

  getAccounts(line: any[]): string {
    if (!line || line.length === 0) return 'N/A';
    return line
      .map((l) => l.AccountBasedExpenseLineDetail?.AccountRef?.name)
      .filter((name) => !!name)
      .join(', ');
  }

  getDescription(line: any[]): string {
    if (!line || line.length === 0) return 'N/A';
    return line
      .map((l) => {
        const description = l.Description || 'N/A';
        return `${description}`;
      })
      .join(', ');
  }
}
